/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterW = createReactComponent("letter-w", "IconLetterW", [
  ["path", { d: "M4 4l4 16l4 -14l4 14l4 -16", key: "svg-0" }]
]);

export { IconLetterW as default };
//# sourceMappingURL=IconLetterW.js.map
